import type { Nullable } from "@msuite/utils/types";
import QR from "react-qr-code";
import { Icon } from "../icons";

/** Props Interface */
interface QRCodeProps {
	value: Nullable<string>;
}

export function QRCode({ value }: QRCodeProps) {
	if (!value) return <Icon name="QrCode" />;

	/** Render */
	return (
		<QR
			value={value}
			size={200}
		/>
	);
}
